export default __webpack_public_path__ + "static/media/FG_65.38644f42.png";